import ApiService from "./ApiService";

const UsageService = {
    getCurrentMonthUsageByProject: async function (projectId) {
        const endpoint = `/usage/project/${projectId}`;
        return await ApiService.get(endpoint);
    },
    getCurrentMonthUsageByUser: async function () {
        const endpoint = "/usage/current";
        return await ApiService.get(endpoint);
    },
    getUsageHistory: async function (page = 1, pageSize = 5) {
        const endpoint = `/usage/history?page=${page}&pageSize=${pageSize}`;
        return await ApiService.get(endpoint);
    },
};

export default UsageService;
